<template>
	<swiper
		:effect="fade"
		:modules="modules"
		:slides-per-view="6"
		:space-between="10"
		navigation
		:grabCursor="true"
		:loop="true"
		:breakpoints="{
			'320': {
				slidesPerView: 1,
				spaceBetween: 10,
			},
			'400': {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			'576': {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			'768': {
				slidesPerView: 4,
				spaceBetween: 10,
			},
			'992': {
				slidesPerView: 5,
				spaceBetween: 10,
			},
			'1200': {
				slidesPerView: 6,
				spaceBetween: 10,
			},
		}"
		@swiper="onSwiper"
		@slideChange="onSlideChange"
		class="promotional-slider"
	>
		<swiper-slide
			v-for="actionCard in actionCards"
			:key="actionCard.id"
			class="slider-slide"
			:style="`background: linear-gradient(${actionCard.frame_gradient})`"
		>
			<div class="slider-slide__inner d-flex block-center"
				@click="showPromotionalModal(actionCard)"
			>
				<div
					class="slider-slide__image d-flex justify-center items-end"
					:style="`background: linear-gradient(${actionCard.card_gradient});`"
				>
					<img
						:src="`${actionCard.image}`"
						alt="promotional slide image"
						class="slider-slide__image-img"
					/>
				</div>
				<span class="slider-slide__title" :style="`color: ${actionCard.text_color};`">{{ actionCard.content }}</span>
			</div>
		</swiper-slide>
	</swiper>

	<Transition name="modal-fade">
		<promotional-modal
				v-show="promotionalModal"
				@close-modal="promotionalModal = false"
				:promotional="promotional"
		/>
	</Transition>
</template>
<script>
// Import Swiper Vue.js components
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { api } from '@/api';
import PromotionalModal from './PromotionalModal.vue';

export default {
	components: {
		Swiper,
		SwiperSlide,
		PromotionalModal,
	},
	data() {
		return {
			actionCards: [],
			promotionalModal: false,
			promotional: null,
		};
	},
	async mounted() {
		this.actionCards = await this.loadActionCards();
	},
	setup() {
		const onSwiper = (swiper) => {
			console.log(swiper);
		};
		const onSlideChange = () => {
			console.log('slide change');
		};
		return {
			onSwiper,
			onSlideChange,
			modules: [EffectFade, Navigation, Pagination],
		};
	},
	methods: {
		async loadActionCards() {
			return await api.getActionCards().then((response) => {
				return response.data;
			});
		},
		showPromotionalModal(card) {
			this.promotional = card;
			this.promotionalModal = true;
			document.body.classList.add('hidden');
		},
	},
};
</script>
